// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const SalaryStructurePage = lazy(() => import('./pages/SalaryStructurePage'));
const PayrollRunPage = lazy(() => import('./pages/PayrollRunPage'));
const TaxDeductionsPage = lazy(() => import('./pages/TaxDeductionsPage'));
const StatutoryCompliancePage = lazy(() => import('./pages/StatutoryCompliancePage'));
const PayslipsPage = lazy(() => import('./pages/PayslipsPage'));
const BonusVariablePage = lazy(() => import('./pages/BonusVariablePage'));
const MultiCurrencyPayrollPage = lazy(() => import('./pages/MultiCurrencyPayrollPage'));
const StatutoryExportsPage = lazy(() => import('./pages/StatutoryExportsPage'));

export const PayrollRoutes: RouteObject = {
  path: 'payroll',
  element: <ModuleGuard moduleId="people.payroll" />,
  handle: { crumb: 'Payroll' },
  children: [
    { index: true, element: <Navigate to="salary-structure" replace /> },
    { path: 'salary-structure', element: <SalaryStructurePage />, handle: { crumb: 'Salary Structure' } },
    { path: 'payroll-run', element: <PayrollRunPage />, handle: { crumb: 'Payroll Run' } },
    { path: 'tax-deductions', element: <TaxDeductionsPage />, handle: { crumb: 'Tax Deductions' } },
    { path: 'statutory-compliance', element: <StatutoryCompliancePage />, handle: { crumb: 'Statutory Compliance' } },
    { path: 'payslips', element: <PayslipsPage />, handle: { crumb: 'Payslips' } },
    { path: 'bonus-variable', element: <BonusVariablePage />, handle: { crumb: 'Bonus Variable' } },
    { path: 'multi-currency-payroll', element: <MultiCurrencyPayrollPage />, handle: { crumb: 'Multi Currency Payroll' } },
    { path: 'statutory-exports', element: <StatutoryExportsPage />, handle: { crumb: 'Statutory Exports' } },
  ],
};
